/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Text, theme } from "@nordcloud/gnui";
import { NoData } from "../NoData";
import { SidebarItem } from "./SidebarItem";
import { Item } from "./types";

type Props = {
  items: Item[];
  itemsTitle?: string;
  onSubmit: (item: Item) => void;
};

export function SidebarItemList({ itemsTitle, items, onSubmit }: Props) {
  if (items.length === 0) {
    return <NoData message="no data" />;
  }
  return (
    <>
      <Headline>
        <Text size="sm" color={theme.color.text.text02}>
          {itemsTitle ?? "Name"}
        </Text>
      </Headline>
      {items.map((item) => (
        <SidebarItem
          key={item.value}
          item={item}
          onSubmit={() => onSubmit(item)}
        />
      ))}
    </>
  );
}

const Headline = styled.div`
  border-bottom: 2px solid ${theme.color.border.border01};
`;
